<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Fj1HdR/tc-custom/9781452175973.jpg?1740638109375" alt="This image is the cover for the book Get Up, Stand Up"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Get Up, Stand Up
      </h1>
      <p class="bookDescription body article font2">
        <b>The third picture book adaptation of one of Bob Marley's beloved songs that has a timely message for children: To counter injustice, lift others up with kindness and courage.</b><br/><br/><b>A heartfelt and meaningful book that brings Bob Marley's music to life in a new way:</b> As a young girl goes on with her day in school, she comes across several instances of teasing and intimidation. But with loving action and some help from her friends, she's able to make things right for herself and others.<br/><br/>• This cute children's book includes the impactful lyrics of Bob Marley's song 'Get Up, Stand Up' that has inspired millions of listeners around the world with messages of peace, love, and truth<br/>• Written by Cedella Marley, Bob Marley's daughter, who has dedicated herself to keeping her father's message and memory alive<br/>• With exuberant pictures by John Jay Cabuay accompanying Marley's iconic lyrics, <i>Get Up, Stand Up</i> is a vibrant testament to the power we all have to make a difference<br/><br/><b>Fans of <i>Every Little Thing</i> and <i>One Love</i> will also love the lyrical rhythm and the powerful message of love, peace, and harmony presented in <i>Get Up, Stand Up</i>.</b><br/><br/>• Great family and classroom read-aloud book<br/>• Appeals to readers of all ages with the light-hearted tone and cheerful illustrations<br/>• Books for kids ages 6–8<br/>• Children's books for early elementary students
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Marley, Cedella Marley, John Jay Cabuay
      </h2>
      
      <p class="authorDescription body article">Bob Marley (1945&ndash;1981) was one of the most beloved and bestselling musicians of his time. Born in the village of Nine Mile, Jamaica, Marley left school at fourteen to pursue music fulltime. A dedicated member of the Rastafari movement, Marley is credited with bringing reggae and Jamaican music to a world stage. Over the course of his career, he released more than a dozen albums with his band Bob Marley and the Wailers. The posthumous release of <i>Legend </i>(1984) went platinum in the United States and sold more than 25 million copies worldwide. Marley died from cancer in 1981.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b4cae23